module.exports = __webpack_public_path__ + "img/pic-14.8cdd66e5.jpg";